module.exports = __webpack_public_path__ + "img/item5.c0384721.jpg";